import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const TenantId = 'TenantId'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

// Lyods TenantId
export function getTenantId() {
  return Cookies.get(TenantId)
}

export function setTenantId(id) {
  return Cookies.set(TenantId, id)
}

export function removeTenantId() {
  return Cookies.remove(TenantId)
}

// Lyods getTimeOffset
export function getTimeOffset() {
  return new Date().getTimezoneOffset();
}


// WEBPACK FOOTER //
// ./src/utils/auth.js